import React, { useContext } from 'react';

import styled from 'styled-components';

import { AttendanceContext } from '../../context/AttendanceContext';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 6rem;
`;

const AttendanceError: React.FC = () => {
    const { t, error } = useContext(AttendanceContext);

    return (
        <Container>
            <span>
                <strong>{t('error-occurred', { error })}</strong>
            </span>
        </Container>
    );
};

export default AttendanceError;
